import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { loadingInterceptor } from './shared/interceptors/loading.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SessionService } from './shared/services/session.service';
import { LearnerService } from './learner/learner.service';
import { LocalStorageKey } from './shared/constants';
import { AppPreBootstrap } from './AppPreBootstrap';
import { catchError, firstValueFrom, of, tap } from 'rxjs';
import { ThemeService } from './shared/services/theme.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptors([authInterceptor, loadingInterceptor])),
    importProvidersFrom(NgxSpinnerModule),
    providePrimeNG({ theme: { preset: Aura } }),
    provideAppInitializer(() => {
      // Restore the portal theme before waiting for remote configuration or profile data.
      inject(ThemeService);
      const session = inject(SessionService);
      const learnerService = inject(LearnerService);

      return AppPreBootstrap.run().then(() => {
        const token = localStorage.getItem(LocalStorageKey.token);
        const userId = Number(localStorage.getItem(LocalStorageKey.userId));
        if (!token || !userId) return;
        return firstValueFrom(
          learnerService.getUserProfile(userId).pipe(
            tap((res) => { if (res.success) session.setUser(res.result); }),
            catchError(() => of(null))
          )
        );
      });
    }),
  ],
};
